export const extendContainer = {
    container: ({ inNavigation, theme: { colors } }) => ({
        marginTop: '2rem',
        paddingTop: '2.5rem',
        alignItems: 'center',
        flexWrap: 'wrap',
        gridRowGap: '1rem',
        borderTop: `1px solid ${colors.borderGrey}`,

        maxWidth: 610,
        justifySelf: 'end',

        tablet: {
            width: 'unset',
            borderTop: 0,
            marginTop: 0,
            paddingTop: !inNavigation && '2.5rem',
        },

        tabletLarge: {
            gridColumnGap: !inNavigation ? '1rem' : undefined,
            paddingTop: !inNavigation ? '3rem' : 0,
        },
    }),
};

export const contactContainer = () => ({
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
});

export const contactIconContainer = ({ theme: { colors } }) => ({
    fill: colors.blue,
});
